// @flow
/* eslint-disable camelcase */
import React from "react";
import "./stylesheets/Preview.scss";

type Props = {
  form: Object,
  appIconUrl: string,
  appName: string
};

const Preview = (props: Props) => {
  const { title, subtitle, body = "", attachment_url } = props.form;
  const { appIconUrl, appName } = props;
  return (
    <div className="Preview">
      <div className="Preview__Background">
        <div className="Notification">
          <div className="Notification__HeaderContainer">
            <img
              className="Notification__AppIcon"
              src={appIconUrl}
              alt="app icon"
              width="20px"
              height="20px"
            />
            <div className="Notification__AppName">{appName}</div>
          </div>
          <div className="Notification__BodyContainer">
            {attachment_url && (
              <img
                id="rich-img"
                src={attachment_url}
                alt="Can't find your media: check your URL."
                style={{
                  width: "100%",
                  objectFit: "contain"
                }}
              />
            )}
            <div style={{ padding: "10px 15px 15px 10px" }}>
              <div className="Notification__Title">{title}</div>
              <div className="Notification__Subtitle">{subtitle}</div>
              <div className="Notification__BodyText">
                {body.split(/\n/).map((word, index) => (
                  /* eslint-disable react/no-array-index-key */
                  <span key={index}>
                    {word}
                    <br />
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;



// WEBPACK FOOTER //
// ./node_modules/@localytics/push-message-builder/src/components/Preview.jsx